

import { Vue} from "vue-property-decorator"

export default class Tirscript3TableFilterComponent extends Vue {

}
